import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateQueue } from '../../api/production-request-api/index.js';
import { toast } from '@pella/sash-framework';
import { QUERY_KEYS } from '../../data/constants';
import { useAppContext } from '../../providers';

/**
 * Hook containing mutation function for updating a Queue.
 */
export const useUpdateQueue = () => {
  const queryClient = useQueryClient();
  const { selectedPlant } = useAppContext();

  return useMutation({
    /**
     * mutateFn - Function to call updateQueue.
     * @param {object} params
     * @param {Pella.ProductionRequestAPI.Plant['id']} params.id - The ID of the Queue to update.
     * @param {Pella.ProductionRequestAPI.UpdateQueueInput} params.input - The inputs for updating the Queue.
     */
    mutationFn: ({ id, input }) => updateQueue(id, input),
    onSuccess: () => {
      toast.dismiss();
      toast.success('Queue updated successfully!');
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.QUEUE_DATA, selectedPlant] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.RESOURCE_DATA, selectedPlant] });
    },
  });
};
